module.exports = __webpack_public_path__ + "images/shoebox2-0700f4a90fc075a08c13a1fcc3cb831c.jpg";